// router
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

// mui
import { Box, BoxProps, Container, Link, LinkProps, Typography } from '@mui/material';

// icons
import { ChevronRight as IconChevronRight } from '@mui/icons-material';

// props
export type Crumb = LinkProps & RouterLinkProps;

export interface BreadcrumbsProps {
	crumbs: Crumb[];
	page: string | undefined;
}

export const Breadcrumbs = ({ crumbs, page }: BreadcrumbsProps) => {
	// vars
	const sxLi: BoxProps['sx'] = (theme) => {
		return {
			listStyle: 'none',
			display: 'flex',
			alignItems: 'center',
			'&:last-child': {
				color: theme.palette.brand.grey[500],
			},
		};
	};

	return (
		<Box
			component="nav"
			aria-label="Breadcrumb"
			sx={(theme) => {
				return {
					padding: theme.spacing(3, 0, 0, 0),
				};
			}}>
			<Container maxWidth={false}>
				<Box
					component="ul"
					sx={(theme) => {
						return {
							display: 'flex',
							margin: 0,
							padding: 0,
							flexWrap: 'wrap',
						};
					}}>
					{crumbs.map((link) => {
						return (
							<Box component="li" key={`crumb-${link.to}`} sx={sxLi}>
								<Link component={RouterLink} fontWeight={600} to={link.to} underline="hover">
									{link.children}
								</Link>
								<IconChevronRight />
							</Box>
						);
					})}
					{page && (
						<Box component="li" sx={sxLi}>
							<Typography fontWeight={600}>{page}</Typography>
						</Box>
					)}
				</Box>
			</Container>
		</Box>
	);
};
